import { render, staticRenderFns } from "./FormattedText.vue?vue&type=template&id=186b3b2d"
import script from "./FormattedText.vue?vue&type=script&lang=js"
export * from "./FormattedText.vue?vue&type=script&lang=js"
import style0 from "./FormattedText.vue?vue&type=style&index=0&id=186b3b2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports